import React from 'react'
import Layout from '../components/layout'
import ContactForm from '../components/form'

const Contact = () => {
    return (
        <Layout>
            <ContactForm/>
        </Layout>
    )
}

export default Contact